import { AxiosInstance } from 'axios';

import { PLGTrialAPIApiFactory } from '@cast/openapi-organization-management';

import { AXIOS_CONFIGURATION } from '../constants';

export const PlgTrialApiAdapter = (client: AxiosInstance) => {
  const plgTrialGeneratedApi = PLGTrialAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getTrialStatus: plgTrialGeneratedApi.pLGTrialAPIGetOrganizationTrial,
    startTrial: plgTrialGeneratedApi.pLGTrialAPIStartOrganizationTrial,
    markSalesContacted:
      plgTrialGeneratedApi.pLGTrialAPIMarkSalesContactedOrganizationTrial,
  };
};
